import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import React from 'react';

const prefix = 'itemDownloadedPage';
export function ItemDownloadedPage() {
  const header = <FormattedMessage id={`${prefix}.successMessage`} defaultMessage="Downloaded successful" />;
  const subheader = (
    <FormattedMessage
      id={`${prefix}.successDescription`}
      defaultMessage="You've successfully downloaded your completed item."
    />
  );
  const image = '/item-downloaded.png';

  const { pdfUrl } = useSelector((state) => ({
    pdfUrl: state.auth.user.pdfObjectUrl,
  }));

  return (
    <div className="view-error-page">
      <div className="ui hidden divider"></div>
      <div className="custom-header mark">{header}</div>
      <div className="description">
        <p> {subheader}</p>
      </div>
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered huge image error-image" src={image} alt="unlink" />
          <iframe src={pdfUrl} hidden data-testid="pdfIframe"></iframe>
        </div>
      </div>
    </div>
  );
}
